
import { computed, defineComponent, PropType, toRef } from '@nuxtjs/composition-api'
import { Component } from 'vue'
import type { KlevuFilterResultOptions } from '@klevu/core'
import { KlevuFilterResultSlider } from '@klevu/core/dist/cjs/models/KlevuApiRawResponse'
import { ZaprooKlevuFilterManager } from '~/modules/klevu-search/classes/ZaprooKlevuFilterManager'
import BaseCheckbox from '~/components/atoms/BaseCheckbox.vue'
import NumericRangeFilter from '~/components/organisms/Filter/NumericRangeFilter.vue'
import { safeComputed } from '~/modules/helpers'

export default defineComponent({
  name: 'KlevuFilterSlider',
  components: { NumericRangeFilter, BaseCheckbox },
  props: {
    wrapper: {
      type: Object as PropType<Component>,
      default: undefined
    },
    filter: {
      type: Object as PropType<KlevuFilterResultSlider>,
      required: true
    },
    filterManager: {
      type: Object as PropType<ZaprooKlevuFilterManager>,
      required: true
    }
  },
  emits: ['filterChanged'],
  setup (props, { emit }) {
    const filter = toRef(props, 'filter')

    const min = computed(() => Math.ceil(parseFloat(props.filter.min)))
    const max = computed(() => Math.ceil(parseFloat(props.filter.max)))

    const modelValue = safeComputed<number[]>(() => {
      return [
        parseFloat(props.filter.start) || min.value,
        parseFloat(props.filter.end) || max.value
      ]
    })

    function onValueChange (option: KlevuFilterResultOptions['options'][number], value:boolean):void {
      option.selected = value
    }

    function handleChange ([min, max]):void {
      filter.value.start = min.toString()
      filter.value.end = max.toString()
      emit('filterChanged', filter.value)
    }

    return {
      modelValue,
      min,
      max,
      onValueChange,
      handleChange
    }
  }
})

